export const blockIconsActivitiesSportsNew = (
	<span className='material-symbols-outlined'>sports</span>
);
